type SmoothScrollToFn = (
  target: Element,
  options: { duration?: number; offset?: number; callback?: () => void },
) => void;

export const smoothScrollTo: SmoothScrollToFn = (target, { duration = 500, offset = 0, callback }): void => {
  const start: number = window.scrollY;
  const targetPosition: number = target.getBoundingClientRect().top;
  const startTime: number = performance.now();

  const easeInOutQuad = (t: number): number => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);

  const scrollStep = (currentTime: number): void => {
    const elapsed: number = currentTime - startTime;
    const progress: number = Math.min(elapsed / duration, 1); // Ensure progress doesn't exceed 1
    const ease: number = easeInOutQuad(progress);

    window.scrollTo(0, start + (targetPosition + offset) * ease);

    if (progress < 1) {
      requestAnimationFrame(scrollStep);
    } else if (callback) {
      callback();
    }
  };

  requestAnimationFrame(scrollStep);
};

export const isElementInViewport = (element: Element): boolean => {
  const { top, left, bottom, right } = element.getBoundingClientRect();

  return (
    top >= -1 &&
    left >= 0 &&
    bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const isElementPartiallyVisible = (element: Element): boolean => {
  const rect = element.getBoundingClientRect();

  const isVisible = rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;

  return isVisible;
};
